import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_LOCATION_TYPE_SIMPLE_DETAILS_MUTATION } from '../graphql/mutations'
import { transformToUpdateLocationTypeDescriptionArgs } from '../graphql/transformers'
import { UPDATE_LOCATION_TYPE_SIMPLE_DETAILS } from '../redux/action-types'

const useUpdateLocationTypeSimpleDetailsMutation = () => {
  const dispatch = useDispatch()
  const { isSimpleDetailsLoading, simpleDetailsError } = useSelector(
    store => store.locationTypes.locationType,
  )

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_LOCATION_TYPE_SIMPLE_DETAILS_MUTATION,
        { id, data: transformToUpdateLocationTypeDescriptionArgs(data) },
        dispatch,
        UPDATE_LOCATION_TYPE_SIMPLE_DETAILS,
      ),
    [dispatch],
  )

  return [
    mutate,
    { isLoading: isSimpleDetailsLoading, error: simpleDetailsError },
  ]
}

export default useUpdateLocationTypeSimpleDetailsMutation
